import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressSection", "readySection", "errorSection", "downloadLink"]
  static values = {
    competitionId: Number,
    statusUrl: String
  }

  connect() {
    console.log("Result PDF Status controller connected")
    // Начинаем проверку статуса
    this.checkStatus()
    // Устанавливаем интервал проверки каждые 10 секунд
    this.statusInterval = setInterval(() => this.checkStatus(), 10000)
  }

  disconnect() {
    // Очищаем интервал при отключении контроллера
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.statusUrlValue, {
        headers: {
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      console.log("Status response:", data)

      this.updateUI(data)
    } catch (error) {
      console.error("Error checking PDF status:", error)
    }
  }

  updateUI(data) {
    const status = data.status

    if (status === "result_pdf_ready" && data.pdf_ready && data.pdf_url) {
      // PDF готов
      this.showReady(data.pdf_url)
    } else if (status === "result_pdf_failed") {
      // Произошла ошибка
      this.showError()
    } else {
      // Генерация в процессе (in_queue или in_progress)
      this.showProgress()
    }
  }

  showProgress() {
    this.progressSectionTarget.classList.remove("d-none")
    this.readySectionTarget.classList.add("d-none")
    this.errorSectionTarget.classList.add("d-none")
  }

  showReady(pdfUrl) {
    // Останавливаем проверку статуса
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
      this.statusInterval = null
    }

    this.progressSectionTarget.classList.add("d-none")
    this.readySectionTarget.classList.remove("d-none")
    this.errorSectionTarget.classList.add("d-none")

    // Устанавливаем ссылку на скачивание
    this.downloadLinkTarget.href = pdfUrl
  }

  showError() {
    // Останавливаем проверку статуса
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
      this.statusInterval = null
    }

    this.progressSectionTarget.classList.add("d-none")
    this.readySectionTarget.classList.add("d-none")
    this.errorSectionTarget.classList.remove("d-none")
  }
}
